"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logs = void 0;
const info = (...params) => {
    console.info(...params);
};
const warn = (...params) => {
    console.warn(...params);
};
const error = (...params) => {
    console.error(...params);
};
exports.logs = {
    info,
    warn,
    error,
};
//# sourceMappingURL=logs.js.map